// extracted by mini-css-extract-plugin
export default {"cls1":"CollapsedActivity-cls1___ebd00a91f3aad160616","cls2":"CollapsedActivity-cls2___63b8f6b330b9f9b0e7e CollapsedActivity-cls1___ebd00a91f3aad160616"};